// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__lRHCr","rotate":"Spinner_rotate__tcFNt","dash":"Spinner_dash__uN241"};